import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { TemplateCenterCard } from "../..";
import { Spin } from "antd";
function TemplateCenterCards(param) {
    let { templates, showHidden, showDisabled = true, ...rest } = param;
    const [initialLoaded, setInitialLoaded] = useState(false);
    useEffect(()=>{
        if (!initialLoaded && templates.length > 0) {
            setInitialLoaded(true);
        }
    }, [
        initialLoaded,
        templates.length
    ]);
    return templates.length > 0 || initialLoaded ? /*#__PURE__*/ _jsx(_Fragment, {
        children: templates.filter((param)=>{
            let { isHidden } = param;
            return showHidden ? true : !isHidden;
        }).filter((param)=>{
            let { consumerData: { isDisabled } } = param;
            return showDisabled ? true : !isDisabled;
        }).map((template)=>/*#__PURE__*/ _jsx(TemplateCenterCard, {
                template: template,
                ...rest
            }, template.identifier))
    }) : /*#__PURE__*/ _jsx(Spin, {
        spinning: true,
        style: {
            marginTop: 10
        }
    });
}
export { TemplateCenterCards };
